import { Grid, Box, Typography, Icon } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import {
  Translator,
  formatMoney,
  ReplaceAllInstances,
  enumsCashback,
} from '@itarget/shared'

const useStyles = makeStyles((theme) => ({
  gridStyle: {
    gap: theme.spacing(1),
    padding: theme.spacing(1.5, 1),
  },
  ChipStyle: {
    display: 'flex',
    alignItems: 'center',
    lineHeight: 'normal',
    height: 'fit-content',
    gap: theme.spacing(1),
    padding: theme.spacing(0.5, 1),
    borderRadius: theme.shape.borderRadius,
    '& .MuiChip-label': {
      padding: 0,
      fontSize: 10,
    },
  },
  ChipDefaultStyle: {
    backgroundColor: theme.palette.chipCashback.default.color,
    '& $label': {
      color: theme.palette.chipCashback.default.text,
    },
    '& $icon': {
      color: theme.palette.chipCashback.default.text,
    },
  },
  ChipRedemptionStyle: {
    backgroundColor: theme.palette.chipCashback.redemption.color,
    '& $label': {
      color: theme.palette.chipCashback.redemption.text,
    },
    '& $icon': {
      color: theme.palette.chipCashback.redemption.text,
    },
  },
  label: {
    lineHeight: 1.08,
    fontWeight: '500',
    fontSize: theme.typography.pxToRem(12),
  },
  icon: {
    '&.material-icons': {
      fontSize: theme.typography.pxToRem(12),
    },
  },
}))

const ChipCashback = (props) => {
  const {
    className = '',
    removeWhenMoreThanOne = true,
    factor = 0,
    factorType,
    payWithCashback,
    payWithCashbackPercentage = 0,
  } = props
  const { PRODUCTS_CAMPINGS } = enumsCashback
  const { toReal } = formatMoney
  const styles = useStyles()
  let fixe = 0
  const hasFixe = !!factor && factorType === PRODUCTS_CAMPINGS.FACTOR_TYPE.FIXE
  if (hasFixe) {
    fixe = Number(factor).toFixed(2)
  }

  let percentage = 0
  const hasPercentage =
    !!factor && factorType === PRODUCTS_CAMPINGS.FACTOR_TYPE.MULTIPLIER
  if (hasPercentage) {
    percentage = (Number(factor) * 100).toFixed(0)
  }

  const canPayWithCashback =
    payWithCashback === PRODUCTS_CAMPINGS.PAY_WITH_CASHBACK.ALLOWED

  const chipCashback = {
    fixe: {
      value: toReal(fixe),
      rule: hasFixe,
      className: styles.ChipDefaultStyle,
      translation: Translator({ transRef: 'Acumule R$ %s em cashback' }).props
        .children,
    },
    percentage: {
      value: percentage,
      rule: hasPercentage,
      className: styles.ChipDefaultStyle,
      translation: Translator({ transRef: 'Acumule %s% em cashback' }).props
        .children,
    },
    redemption: {
      value: payWithCashbackPercentage ? Number(payWithCashbackPercentage) : 0,
      rule: canPayWithCashback,
      className: styles.ChipRedemptionStyle,
      translation: Translator({ transRef: 'Resgate até %s% com seu cashback' })
        .props.children,
    },
  }

  const hasChipCashbackToShow = Object.values(chipCashback).some(
    (value) => value.rule === true,
  )

  const returnNull =
    !hasChipCashbackToShow ||
    (removeWhenMoreThanOne && (hasFixe || hasPercentage) && canPayWithCashback)

  if (returnNull) return <></>

  return (
    <Box
      flex={1}
      padding={1}
      display="flex"
      flexWrap="wrap"
      alignItems="flex-end"
      className={`${styles.gridStyle} ${className}`}
      container
    >
      {Object.entries(chipCashback).map(
        ([key, { rule, value, className, translation }]) => {
          if (!rule) return null
          return (
            <Grid item key={key} className={`${styles.ChipStyle} ${className}`}>
              <Icon className={styles.icon}>all_inclusive</Icon>
              <Typography className={styles.label}>
                {ReplaceAllInstances(translation, [value])}
              </Typography>
            </Grid>
          )
        },
      )}
    </Box>
  )
}

export default ChipCashback
